const initialState = () => ({
  isOpened: false,
  payload: null,
  action: null
});

const ACTION_KEY = 'VISITATION_CHANGE_STATUS_MODAL';

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${ACTION_KEY}_OPEN`: {
      return {
        ...state,
        isOpened: true,
        payload: action.payload,
        action: action.action
      };
    }
    case `${ACTION_KEY}_CLOSE`: {
      return initialState();
    }
    default:
      return state;
  }
};

export default reducer;
